import React, { useState } from "react";
import Breadcrumb from "../../../../core/common/Breadcrumb/breadcrumb";
import { Link } from "react-router-dom";
import ProfileCard from "../../common/profileCard";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { User } from "../../../../core/types/types";
import { updateUser } from "../../../../core/redux/authSlice";
import CustomSelect from "../../../../core/common/commonSelect";
import { Country } from "../../../../core/common/selectOption/json/selectOption";
import apiInstance from "../../../../utility/apiInstance";
import { ALPHA_REGEX, stripNonAlpha, ZIP_REGEX, stripNonZip } from "../../../../utility/inputValidators";
import RecruiterSidebar from "../../common/recruiterSidebar";
import SettingsLinks from "../settingsLinks/settingsLinks";

const RecruiterBusinessProfile = () => {

    const user = useSelector((state: any) => state.auth.user);
    const dispatch = useDispatch();

    const [msg, setMsg] = useState({
        error: false,
        loading: false,
        text: ''
    });

    const [errorField, setErrorField] = useState('');

    const [formData, setFormData] = useState<User>({
        id: user?.id || '',
        businessInfo: {
            companyName: user?.businessInfo?.companyName || '',
            website: user?.businessInfo?.website || '',
            studentMainCountry: user?.businessInfo?.studentMainCountry || '',
            streetAddress: user?.businessInfo?.streetAddress || '',
            city: user?.businessInfo?.city || '',
            state: user?.businessInfo?.state || '',
            zipCode: user?.businessInfo?.zipCode || '',
            country: user?.businessInfo?.country || '',
        }
    })

    const handleInputChange = (e: { target: { name: string; value: string | number } }) => {
        const { name } = e.target;
        let { value } = e.target;

        if (typeof value === 'string') {
            if (name === 'city' || name === 'state') {
                value = stripNonAlpha(value);
            } else if (name === 'zipCode') {
                value = stripNonZip(value);
            }
        }

        setFormData((prevState) => ({
            ...prevState,
            businessInfo: {
                ...(prevState.businessInfo ?? {}),
                [name]: value
            }
        }));
        if (errorField === name) setErrorField('');
    };


    const validate = () => {
        let newErrors = '';
        let invalidField = '';

        if (!formData.businessInfo?.companyName?.trim()) {
            newErrors = "Company name is required";
            invalidField = 'companyName';
        } else if (!formData.businessInfo?.studentMainCountry?.trim()) {
            newErrors = "Main source of students is required";
            invalidField = 'studentMainCountry';
        } else if (!formData.businessInfo?.streetAddress?.trim()) {
            newErrors = "Street address is required";
            invalidField = 'streetAddress';
        } else if (!formData.businessInfo?.city?.trim() || !ALPHA_REGEX.test(formData.businessInfo.city)) {
            newErrors = "Valid city is required";
            invalidField = 'city';
        } else if (!formData.businessInfo?.state?.trim() || !ALPHA_REGEX.test(formData.businessInfo.state)) {
            newErrors = "Valid state is required";
            invalidField = 'state';
        } else if (!formData.businessInfo?.zipCode?.trim() || !ZIP_REGEX.test(formData.businessInfo.zipCode)) {
            newErrors = "Valid ZIP code is required";
            invalidField = 'zipCode';
        } else if (!formData.businessInfo?.country?.trim()) {
            newErrors = "Country is required";
            invalidField = 'country';
        }

        setErrorField(invalidField);

        setMsg({
            error: true,
            loading: false,
            text: newErrors
        })

        return newErrors.length === 0
    };

    const updateProfile = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!validate()) return;

        setMsg({
            error: false,
            loading: true,
            text: ''
        });

        try {
            const response = await apiInstance.patch(`/api/users/${formData.id}`, formData)
            dispatch(updateUser(response.data.doc))
            setMsg({
                error: false,
                loading: false,
                text: 'Business profile updated successfully!'
            });

        } catch (error: any) {
            setMsg({
                error: true,
                loading: false,
                text: error.message
            });
        }
    }

    return (
        <>
            <div className="content">
                <div className="container">
                    {/* P[name]: valurofile */}
                    <ProfileCard />
                    {/* /Profile */}
                    <div className="row">
                        {/* Sidebar */}
                        <RecruiterSidebar />
                        {/* Sidebar */}
                        <div className="col-lg-9">
                            <div className="mb-3">
                                <h5>Settings</h5>
                            </div>
                            <SettingsLinks />
                            <div className="card">
                                <div className="card-body">
                                    <form onSubmit={updateProfile}>
                                        <div>
                                            <div className="edit-profile-info mb-3">
                                                <h5 className="mb-1">Business Profile</h5>
                                                <p>Edit your business profile</p>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            Company Name <span className="text-danger"> *</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className={`form-control ${errorField === 'companyName' ? 'is-invalid' : ''}`}
                                                            defaultValue=""
                                                            name="companyName"
                                                            value={formData.businessInfo?.companyName}
                                                            onChange={handleInputChange}
                                                        />
                                                        {errorField === 'companyName' && (
                                                            <div className="invalid-feedback d-block">{msg.text}</div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            Website
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className={`form-control ${errorField === 'website' ? 'is-invalid' : ''}`}
                                                            defaultValue=""
                                                            name="website"
                                                            value={formData.businessInfo?.website}
                                                            onChange={handleInputChange}
                                                        />
                                                        {errorField === 'website' && (
                                                            <div className="invalid-feedback d-block">{msg.text}</div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            Main Source Of Students <span className="text-danger"> *</span>
                                                        </label>
                                                        <CustomSelect
                                                            options={Country}
                                                            className={`select d-flex ${errorField === 'studentMainCountry' ? 'is-invalid' : ''}`}
                                                            placeholder="Select"
                                                            name="studentMainCountry"
                                                            value={formData?.businessInfo?.studentMainCountry}
                                                            onChange={(selectedOption) => {
                                                                handleInputChange({
                                                                    target: {
                                                                        name: 'studentMainCountry',
                                                                        value: selectedOption.value
                                                                    }
                                                                });
                                                            }}
                                                        />
                                                        {errorField === 'studentMainCountry' && (
                                                            <div className="invalid-feedback d-block">{msg.text}</div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            Street Address <span className="text-danger"> *</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className={`form-control ${errorField === 'streetAddress' ? 'is-invalid' : ''}`}
                                                            defaultValue=""
                                                            name="streetAddress"
                                                            value={formData.businessInfo?.streetAddress}
                                                            onChange={handleInputChange}
                                                        />
                                                        {errorField === 'streetAddress' && (
                                                            <div className="invalid-feedback d-block">{msg.text}</div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            City <span className="text-danger"> *</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className={`form-control ${errorField === 'city' ? 'is-invalid' : ''}`}
                                                            defaultValue=""
                                                            name="city"
                                                            value={formData.businessInfo?.city}
                                                            onChange={handleInputChange}
                                                        />
                                                        {errorField === 'city' && (
                                                            <div className="invalid-feedback d-block">{msg.text}</div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            State <span className="text-danger"> *</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className={`form-control ${errorField === 'state' ? 'is-invalid' : ''}`}
                                                            defaultValue=""
                                                            name="state"
                                                            value={formData.businessInfo?.state}
                                                            onChange={handleInputChange}
                                                        />
                                                        {errorField === 'state' && (
                                                            <div className="invalid-feedback d-block">{msg.text}</div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            Zip Code <span className="text-danger"> *</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className={`form-control ${errorField === 'zipCode' ? 'is-invalid' : ''}`}
                                                            defaultValue=""
                                                            name="zipCode"
                                                            value={formData.businessInfo?.zipCode}
                                                            onChange={handleInputChange}
                                                        />
                                                        {errorField === 'zipCode' && (
                                                            <div className="invalid-feedback d-block">{msg.text}</div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            Country <span className="text-danger"> *</span>
                                                        </label>
                                                        <CustomSelect
                                                            options={Country}
                                                            className={`select d-flex ${errorField === 'country' ? 'is-invalid' : ''}`}
                                                            placeholder="Select"
                                                            name="country"
                                                            value={formData.businessInfo?.country}
                                                            onChange={(selectedOption) => {
                                                                handleInputChange({
                                                                    target: {
                                                                        name: 'country',
                                                                        value: selectedOption.value
                                                                    }
                                                                });
                                                            }}
                                                        />
                                                        {errorField === 'country' && (
                                                            <div className="invalid-feedback d-block">{msg.text}</div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <button
                                                        className="btn btn-secondary rounded-pill"
                                                        type="submit"
                                                    >
                                                        Update Profile
                                                    </button>
                                                    {msg.loading &&
                                                        <span className="mt-3 fs-14 fw-normal d-flex align-items-center justify-content-center">Updating business profile...</span>
                                                    }
                                                    {!msg.loading && !errorField &&
                                                        <span className={`mt-3 ${msg.error ? 'text-red' : ''} fs-14 fw-normal d-flex align-items-center justify-content-center`}>{msg.text}</span>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default RecruiterBusinessProfile;
